export default [
    {
        path: '/rate-cards',
        name: 'RateCards',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Rate cards',
        },
        components: {
            default: () => import('@views/rates/RateCardIndex.vue'),
        },
    },
    {
        path: '/rate-cards/:id/edit',
        name: 'RateCardEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: ['SUPER', 'OWNER', 'ADMIN', 'MANAGER'],
            denyRoles: null,
            title: 'Edit rate card',
        },
        components: {
            default: () => import('@views/rates/RateCardEdit.vue'),
        },
    },
];
